module.exports = __webpack_public_path__ + "static/media/RoomService_Meal1_Categories_Cat2.47f3ec5c.png";